import { render, staticRenderFns } from "./biography.vue?vue&type=template&id=f7d1d07e&scoped=true"
import script from "./biography.vue?vue&type=script&lang=js"
export * from "./biography.vue?vue&type=script&lang=js"
import style0 from "./biography.vue?vue&type=style&index=0&id=f7d1d07e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d1d07e",
  null
  
)

export default component.exports